import React, { useState, useRef } from 'react';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
import emailjs from '@emailjs/browser';
import { trackCalendlyConversion } from './GoogleTagLoader';
export function ContactSection() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    type: 'success' | 'error' | null;
    message: string;
  }>({
    type: null,
    message: ''
  });
  const formRef = useRef<HTMLFormElement>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({
      type: null,
      message: ''
    });
    const serviceId = 'service_tssw5oa';
    const templateId = 'template_n0i17pc';
    const publicKey = 'x9SabP7t6qZW31W2T';
    emailjs.sendForm(serviceId, templateId, formRef.current!, publicKey).then(result => {
      setSubmitStatus({
        type: 'success',
        message: 'Thank you! We will be in touch shortly to schedule your demo.'
      });
      setFormState({
        name: '',
        email: '',
        phone: '',
        eventType: '',
        message: ''
      });
    }).catch(error => {
      console.error('EmailJS error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'Failed to send. Please try again or email us directly at dan@turnout.info'
      });
    }).finally(() => {
      setIsSubmitting(false);
    });
  };
  return <section id="contact" className="py-20 bg-white" data-id="element-66" data-mp="14e8hwsq635mn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67" data-mp="1zslncn4x4gv">
        <AnimatedSection data-id="element-68" data-mp="1x6g1ijt0z1a">
          <div className="text-center mb-16" data-id="element-69" data-mp="6xknozhhu6ys">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-70" data-mp="6yc6f9pzsa7n">
              Book a 30-Min Intake
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-71" data-mp="fqe5p4obrkgc">
              Tell us your deal size, budget, and ICP. You will have an events
              calendar and a first event proposed within two weeks.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-72" data-mp="pqoi4n2jcnug">
          <AnimatedSection delay={0.2} className="lg:col-span-2" data-id="element-73" data-mp="uozup5k7tcgd">
            <div className="bg-indigo-50 p-8 rounded-2xl border border-indigo-100" data-id="element-74" data-mp="yps3xyt37hcn">
              <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-75" data-mp="2wf1jqwfgqm4y">
                Contact Information
              </h3>
              <div className="space-y-8" data-id="element-76" data-mp="30fv5pk9chqv7">
                <div className="flex items-start" data-id="element-77" data-mp="30gwsglzq41sr">
                  <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-78" data-mp="2sxngqm3qvr0j">
                    <Phone className="h-6 w-6 text-indigo-600" data-id="element-79" data-mp="2o6dy45gm5ny5" />
                  </div>
                  <div data-id="element-80" data-mp="2o4km0an8ebir">
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-81" data-mp="2j6swtodz13i9">
                      Phone
                    </p>
                    <p className="text-lg text-gray-900 font-medium" data-id="element-82" data-mp="2f7adgx1st0hj">
                      630-615-9901
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-83" data-mp="36xyca2g01ts1">
                  <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-84" data-mp="36v2f4gbz794n">
                    <Mail className="h-6 w-6 text-indigo-600" data-id="element-85" data-mp="32tgta5hgrkib" />
                  </div>
                  <div data-id="element-86" data-mp="2xvfdbtfc41b2">
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-87" data-mp="2xyb7r7rz47ur">
                      Email
                    </p>
                    <p className="text-lg text-gray-900 font-medium" data-id="element-88" data-mp="1mgsarx4zl14n">
                      dan@turnout.info
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-89" data-mp="3f46ggqcn7lds">
                  <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-90" data-mp="3f613ca7h5nki">
                    <MapPin className="h-6 w-6 text-indigo-600" data-id="element-91" data-mp="31e30gh4cwnws" />
                  </div>
                  <div data-id="element-92" data-mp="35dvcj3sylc6w">
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-93" data-mp="35fg88wr0f16c">
                      Address
                    </p>
                    <p className="text-lg text-gray-900 font-medium" data-id="element-94" data-mp="1xxygjrofk3a">
                      1755 University Avenue
                      <br data-id="element-95" data-mp="3k42kgplcbctc" />
                      Palo Alto, CA 94301
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.4} className="lg:col-span-3" data-id="element-96" data-mp="28nuppac5h5s8">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-10 h-full" data-id="element-97" data-mp="28qqqd6fdu8kd">
              <div className="mb-8 pb-8 border-b border-gray-100" data-id="element-98" data-mp="2dl4fir3gbjgl">
                <a href="https://calendly.com/dan-at-turnout/turnout-general-30-min-call" target="_blank" rel="noopener noreferrer" onClick={trackCalendlyConversion} className="w-full flex items-center justify-center px-6 py-4 border border-indigo-600 text-lg font-medium rounded-lg text-indigo-600 bg-white hover:bg-indigo-50 transition-colors duration-300 group" data-id="element-99" data-mp="254vn2vz9g1j3">
                  Prefer to book directly? Grab a 30-min intake
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-100" data-mp="1w5s3lqw6lk42" />
                </a>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-101" data-mp="1re0j9y3mcamd">
                Or Send Us a Message
              </h3>

              {submitStatus.type === 'success' && <div className="mb-6 p-4 bg-green-50 text-green-800 rounded-lg border border-green-100" data-id="element-102" data-mp="yr63vflns1fr">
                  {submitStatus.message}
                </div>}
              {submitStatus.type === 'error' && <div className="mb-6 p-4 bg-red-50 text-red-800 rounded-lg border border-red-100" data-id="element-103" data-mp="33q5ubrob91kn">
                  {submitStatus.message}
                </div>}

              <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-104" data-mp="3cizcpxz20h2q">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-105" data-mp="2fubaob3qh4ey">
                  <div data-id="element-106" data-mp="2ksuvu9ai6c69">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107" data-mp="2kscsyttc4zpd">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow" placeholder="Jane Doe" data-id="element-108" data-mp="2tuc79ecytpom" />
                  </div>
                  <div data-id="element-109" data-mp="9g4hc66rvicy">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-110" data-mp="9fcm4wh37mn7">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow" placeholder="jane@company.com" data-id="element-111" data-mp="3rnbtuitujbie" />
                  </div>
                  <div data-id="element-112" data-mp="203immj7ckoae">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-113" data-mp="20522w9t06zc6">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow" placeholder="(555) 123-4567" data-id="element-114" data-mp="1qbv1f01dw3hd" />
                  </div>
                  <div data-id="element-115" data-mp="1cepxb5l8deor">
                    <label htmlFor="eventType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-116" data-mp="1cg1298qewshg">
                      Monthly Event Budget *
                    </label>
                    <select id="eventType" name="eventType" value={formState.eventType} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow" data-id="element-117" data-mp="3gvcrv7qtbupm">
                      <option value="" data-id="element-118" data-mp="3fy8w8i3rsr3">What can you put behind events?</option>
                      <option value="2.5k-5k" data-id="element-119" data-mp="3uoc490vat8sy">$2.5K to $5K</option>
                      <option value="5k-10k" data-id="element-120" data-mp="chxr344ut2vm">$5K to $10K</option>
                      <option value="10k-25k" data-id="element-121" data-mp="cheabqqxwkj6">$10K to $25K</option>
                      <option value="25k+" data-id="element-122" data-mp="8g2sw8i7z5m2">$25K+</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-123" data-mp="2e9sy36g60j7i">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124" data-mp="2ebdl8b05gzvc">
                    Who is your ICP? *
                  </label>
                  <textarea id="message" name="message" value={formState.message} onChange={handleChange} required rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow" placeholder="e.g. Practice owners at 2 to 10 location vet groups in TX/OK" data-id="element-125" data-mp="ubzg3kdiodog"></textarea>
                </div>
                <div data-id="element-126" data-mp="189xvmt3kqg5j">
                  <button type="submit" disabled={isSubmitting} className={`w-full px-6 py-4 border border-transparent text-lg font-bold rounded-lg shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition-all duration-300 ${isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:shadow-md hover:-translate-y-0.5'}`} data-id="element-127" data-mp="1895y3cqf28cm">
                    {isSubmitting ? 'Sending...' : 'Book Intake'}
                  </button>
                </div>
              </form>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}